import React from 'react';
import { CtaBlock } from '../CtaButton';
import { MockupCrop } from '../MockupCrop';
import { Accent, SectionHeading } from './SectionHeading';
import { volumes } from '../../data/content';

/** Section 6 — each core volume in detail. */
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-262" data-mp="7z3t1b5kn142">
      <div className="mx-auto max-w-5xl" data-id="element-263" data-mp="vp7xfkql34w4">
        <SectionHeading id="volumes-heading" title={<>
              6 Volumes. <Accent data-id="element-265" data-mp="10nj7nwksjhev">One Complete Teaching System.</Accent>
            </>} data-id="element-264" data-mp="vq9atvv2o3h0" />

        <ol className="mt-14 space-y-6" data-id="element-266" data-mp="mvurni7f88sm">
          {volumes.map(volume => <li key={volume.number} data-id="element-267" data-mp="qxg6va7fgz5z">
              <article className="grid gap-7 rounded-[24px] border border-brand-charcoal/8 bg-white p-5 shadow-[0_30px_60px_-44px_rgba(59,27,87,0.5)] sm:p-8 md:grid-cols-[250px_1fr] md:gap-10" data-id="element-268" data-mp="qweoeko31ae8">
                <div className="flex items-start justify-center rounded-[18px] bg-brand-paper px-6 py-6" data-id="element-269" data-mp="1jfttser870qa">
                  <MockupCrop crop={volume.crop} alt={`Volume ${volume.number} cover — ${volume.title}`} className="w-full max-w-[210px]" data-id="element-270" data-mp="cj6q56ns1v41" />
                </div>

                <div data-id="element-271" data-mp="hjuflnwcy3w5">
                  <p className="flex items-baseline gap-3" data-id="element-272" data-mp="hjb5uugv2lt7">
                    <span className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-charcoal/50" data-id="element-273" data-mp="vbr5rmegu3pw">
                      Volume {volume.number}
                    </span>
                    <span className="font-display text-[1.6rem] font-bold italic leading-none text-brand-plum" data-id="element-274" data-mp="159x11l5robls">
                      {volume.stage}
                    </span>
                  </p>
                  <h3 className="mt-3 font-display text-[1.7rem] font-bold leading-[1.1] text-brand-charcoal sm:text-[2rem]" data-id="element-275" data-mp="371a8agv7ivl0">
                    {volume.title}
                  </h3>
                  <p className="mt-2 text-[16px] font-medium leading-relaxed text-brand-charcoal/75" data-id="element-276" data-mp="324js7tjejzzl">{volume.benefit}</p>

                  <p className="mt-6 font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/45" data-id="element-277" data-mp="1axvox83hry2n">
                    Includes
                  </p>
                  <ul className="mt-3 grid grid-cols-2 gap-x-6 gap-y-2" role="list" data-id="element-278" data-mp="1f23gdd1c3s4k">
                    {volume.includes.map(item => <li key={item} className="flex items-start gap-2 text-[14px] leading-snug text-brand-charcoal/80" data-id="element-279" data-mp="1oyq01yhxcd50">
                        <span aria-hidden="true" className="mt-[7px] h-1 w-1 flex-none rounded-full bg-brand-gold" data-id="element-280" data-mp="1tvq5c76y9bv2" />
                        {item}
                      </li>)}
                  </ul>

                  <div className="mt-6 rounded-[14px] bg-brand-lavender px-5 py-4" data-id="element-281" data-mp="22ojnccds6pcm">
                    <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-plum" data-id="element-282" data-mp="27pzaqb3fl7y6">
                      Use it when…
                    </p>
                    <p className="mt-1.5 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-283" data-mp="2mrpl2yj5pqwo">{volume.useWhen}</p>
                  </div>
                </div>
              </article>
            </li>)}
        </ol>

        <p className="mt-16 text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-284" data-mp="2ctrysgkuy46p">
          Stop preparing everything <Accent data-id="element-285" data-mp="35igs3tfo957w">from scratch.</Accent>
        </p>
        <CtaBlock label="Yes! I Want My Classes Ready" className="mt-6" data-id="element-286" data-mp="35h5opuq51zhb" />
      </div>
    </section>;
}